import React, { useState } from 'react';
import {
    Button,
    Typography,
    TextField,
    Box
} from '@mui/material';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

const Paso4Ubicacion = ({ onNext, onBack, initialData }) => {
    const [address, setAddress] = useState('');
    const [selectedLocation, setSelectedLocation] = useState(initialData.ubicacion || null);

    const mapContainerStyle = {
        width: '100%',
        height: '400px'
    };

    const center = {
        lat: 4.570868,
        lng: -74.297333
    };

    const handleMapClick = (event) => {
        setSelectedLocation({
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        });
    };

    const handleContinue = () => {
        if (!selectedLocation) {
            alert('Por favor selecciona una ubicación en el mapa');
            return;
        }
        onNext({ ubicacion: selectedLocation });
    };

    return (
        <div>
            <Typography variant="h5" gutterBottom>
                Ubicación de tu propiedad
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 3 }}>
                Selecciona en el mapa la ubicación donde se instalarían los paneles solares
            </Typography>

            <TextField
                fullWidth
                label="Dirección (opcional)"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                margin="normal"
            />

            <Box sx={{ mt: 2, mb: 2 }}>
                <LoadScript googleMapsApiKey="AIzaSyDpZVYF_ugXlx8UGlSqdz0uLc41pqHeAeM">
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={center}
                        zoom={12}
                        onClick={handleMapClick}
                    >
                        {selectedLocation && (
                            <Marker position={selectedLocation} />
                        )}
                    </GoogleMap>
                </LoadScript>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                <Button onClick={onBack}>Atrás</Button>
                <Button
                    variant="contained"
                    onClick={handleContinue}
                    disabled={!selectedLocation}
                >
                    Ver Resumen
                </Button>
            </Box>
        </div>
    );
};

export default Paso4Ubicacion;